export default "__VITE_ASSET__wv0uQSXf__"